import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { PaginatedResponse, UploadedFileData } from "@/types/common.types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type UploadedFileDataResponse = PaginatedResponse<UploadedFileData>;

const getUploadedFiles = async (
  uploadSessionId: number
): Promise<UploadedFileDataResponse> => {
  const response = await apiClient
    .get(`${ENDPOINTS.GET_UPLOADED_DATA(uploadSessionId.toString())}`)
    .json<UploadedFileDataResponse>();

  return response;
};

export const useUploadedFilesQuery = (
  uploadSessionId: number | null,
  options?: Omit<
    UseQueryOptions<UploadedFileDataResponse, Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["uploadedFiles", uploadSessionId],
    queryFn: () => {
      if (uploadSessionId === null) {
        throw new Error("uploadSessionId is null");
      }
      return getUploadedFiles(uploadSessionId);
    },
    ...options,
  });
};
